import createTestId, { getTestId } from "../../../../../fabrics/createTestId";

const CORE_HEADER_PREFIX = "core-header";

export const CORE_HEADER_TEST_ID = getTestId(CORE_HEADER_PREFIX);

export const createTestIdForCoreHeader = createTestId(CORE_HEADER_PREFIX);
